import { SideBarHeading } from "components";
import type { SideBarHeadingProps } from "./SideBarHeading.d";

const SideBarHeadingMagnitudeAdapter = ({ props: [text] }: SideBarHeadingProps) => <SideBarHeading text={text} />;

export default SideBarHeadingMagnitudeAdapter;
